import { Template } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

const TemplatesTableNameCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<Template>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`/template/${template.id}`}>{template.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default TemplatesTableNameCell;
